import React from "react";
import { Drawer } from "Components/Base/Navigation/Drawer";
import BaseGrid from "Components/Fragment/BaseGrid";
import FilterHitCount from "./FilterHitCount";
import CheckboxAdministrator from "./CheckboxAdministrator";
import InputTextSearch from "./InputTextSearch";
import FilterSection from "./FilterSection";
import SelectFilter from "./SelectFilter";
import * as CONSTANTS from "../../constants";

const DrawerFilters = ({
  state,
  setState,
  store,
  mediaClass,
  hitCount,
  showHitCount,
  languageContext,
  setSearchText,
  setFilter,
  setSortBy,
  onSearch,
  mobile = false,
}) => {
  return (
    <Drawer
      anchor="right"
      open={state.drawerOpen}
      onClose={() =>
        setState((prevState) => ({ ...prevState, drawerOpen: false }))
      }
    >
      <div
        className={`course-filter ${mediaClass}`}
        role="search"
        style={{ maxWidth: "250px", padding: "0 2vw" }}
      >
        <BaseGrid
          childWidth="auto"
          justifyContent="space-between"
          alignItems="center"
        >
          <h2>{languageContext("filter")}</h2>
          <FilterHitCount
            hitCount={hitCount && showHitCount ? hitCount : 0}
            languageContext={languageContext}
          />
        </BaseGrid>
        {mobile && (
          <BaseGrid childWidth="auto" spacing={2}>
            <SelectFilter
              name={languageContext("status")}
              options={CONSTANTS.SORT_OPTIONS_STATUS}
              value={store.filter.filter.toLowerCase()}
              onChange={setFilter}
              languageContext={languageContext}
              className="filter-select"
            />
            <SelectFilter
              name={languageContext("sort")}
              options={CONSTANTS.SORT_OPTIONS_ORDER}
              value={state.sortBy}
              onChange={setSortBy}
              languageContext={languageContext}
              className="filter-select"
            />
          </BaseGrid>
        )}
        <BaseGrid childWidth="auto" direction="column">
          {store.isAdmin && (
            <CheckboxAdministrator
              id="ChkOnlyCourseParticipantsCourses"
              value={state.hideAdministratorCourses}
              lang={languageContext}
              onToggle={(newState) =>
                setState((prevState) => ({ ...prevState, ...newState }))
              }
              type="administrator"
            />
          )}
          {store.isAdmin && (
            <CheckboxAdministrator
              id="ChkOnlyAdminCourses"
              value={state.hideParticipantCourses}
              lang={languageContext}
              onToggle={(newState) =>
                setState((prevState) => ({ ...prevState, ...newState }))
              }
              type="participant"
            />
          )}
          <InputTextSearch
            searchText={state.searchText}
            setSearchText={setSearchText}
            onSearch={onSearch}
            languageContext={languageContext}
          />
          <FilterSection
            store={store}
            state={state}
            setState={setState}
            setFilter={setFilter}
            languageContext={languageContext}
          />
        </BaseGrid>
      </div>
    </Drawer>
  );
};

export default DrawerFilters;
